import React from 'react';
import ReactDOM from 'react-dom/client';
import * as helmetModule from 'react-helmet-async';
import App from './App.jsx';
import './index.css';

const HelmetProvider =
  helmetModule.HelmetProvider || helmetModule.default?.HelmetProvider;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);